const InstructorModel = {
  created: "date",
  updated: "date",
  title: "string",
  bio: "string",
  profile_image: "object",
}

export default InstructorModel
